import React from "react";
import type { FormattedValue } from "./shopifyFormatting";

/**
 * Render FormattedValue — handles both string and HTML content.
 * Shared utility extracted from ProductDetailsSection, InventorySection, AdvancedSection.
 */
export function renderFormattedValue(value: FormattedValue): React.ReactNode {
  if (typeof value === "object" && "__html" in value) {
    return <span dangerouslySetInnerHTML={value} />;
  }
  return <>{value}</>;
}
